//@flow
const KAFAIR_RAFFLE_GROUP = "KAFAIR_RAFFLE_GROUP";
const KA_FAIR_RAFFLE = "KA_FAIR_RAFFLE";
const KA_FAIR_RAFFLE_LIST = "KA_FAIR_RAFFLE_LIST";
const SET_USER_RAFFLE_TICKET = "SET_USER_RAFFLE_TICKET";
const KA_FAIR_RAFFLE_LIST_CLOSED = "KA_FAIR_RAFFLE_LIST_CLOSED";
const SET_PRODUCT_RAFFLE_COUNT = "SET_PRODUCT_RAFFLE_COUNT";
const KA_PREVIEW_RAFFLE = "KA_PREVIEW_RAFFLE";
const GET_COLLECTION_KICKFAIR = "GET_COLLECTION_KICKFAIR";
const GET_COLLECTION_STEAL_DEAL = "GET_COLLECTION_STEAL_DEAL";
const GET_COLLECTION_STEAL_DEAL_LIST = "GET_COLLECTION_STEAL_DEAL_LIST";
const GET_COLLECTION_SPECIAL_DEALS_GOLD = "GET_COLLECTION_SPECIAL_DEALS_GOLD";
const GET_COLLECTION_SPECIAL_DEALS_CAPSULE =
  "GET_COLLECTION_SPECIAL_DEALS_CAPSULE";
const GET_IMAGE_BANNER_SPECIAL_DEALS_GOLD =
  "GET_IMAGE_BANNER_SPECIAL_DEALS_GOLD";
const GET_IMAGE_BANNER_SPECIAL_DEALS_CAPSULE =
  "GET_IMAGE_BANNER_SPECIAL_DEALS_CAPSULE";
const GET_LOCAL_BRANDS_PRODUCT = "GET_LOCAL_BRANDS_PRODUCT";
const GET_IMAGE_BANNER_LOCAL_BRANDS = "GET_IMAGE_BANNER_LOCAL_BRANDS";
const GET_LOCAL_BRANDS_BRANDS = "GET_LOCAL_BRANDS_BRANDS";
const SCROLL_TO_SECTION = "SCROLL_TO_SECTION";
const GET_KICKFAIR_SETTING = "GET_KICKFAIR_SETTING";
const GET_IMAGE_BANNER_MERCHANDISE = "GET_IMAGE_BANNER_MERCHANDISE";
const GET_MERCHANDISE_PRODUCT = "GET_MERCHANDISE_PRODUCT";
const KA_POST_RAFFLE_ENTRY = "KA_POST_RAFFLE_ENTRY";
const GET_COLLECTION_LOCAL_BRANDS = "GET_COLLECTION_LOCAL_BRANDS";
const GET_COLLECTION_EXCLUSIVE_LAUNCH = "GET_COLLECTION_EXCLUSIVE_LAUNCH";
const GET_COLLECTION_EXCLUSIVE_LAUNCH_LIST =
  "GET_COLLECTION_EXCLUSIVE_LAUNCH_LIST";
const GET_COLLECTION_SURPRISE_DROP = "GET_COLLECTION_SURPRISE_DROP";
const GET_COLLECTION_SURPRISE_DROP_LIST = "GET_COLLECTION_SURPRISE_DROP_LIST";
const GET_POPULAR_BRANDS = "GET_POPULAR_BRANDS";

//bcaxkickavenue
const GET_COLLECTION_SNEAKERS_NOVEMBAZAR = "GET_COLLECTION_SNEAKERS_NOVEMBAZAR";
const GET_COLLECTION_STREETWEAR_NOVEMBAZAR =
  "GET_COLLECTION_STREETWEAR_NOVEMBAZAR";
const GET_COLLECTION_LUXURY_NOVEMBAZAR = "GET_COLLECTION_LUXURY_NOVEMBAZAR";
const GET_COLLECTION_LIFESTYLE_NOVEMBAZAR =
  "GET_COLLECTION_LIFESTYLE_NOVEMBAZAR";
const GET_SLIDER_PROMO = "GET_SLIDER_PROMO";

//BCA LAUNCH RAFFLE
const GET_RAFFLE_BANNER = "GET_RAFFLE_BANNER";
const SET_PRODUCT_RAFFLE_ENTRY = "SET_PRODUCT_RAFFLE_ENTRY";
const GET_COLLECTION_FLASH_SALE = "GET_COLLECTION_FLASH_SALE";

export {
  KAFAIR_RAFFLE_GROUP,
  KA_FAIR_RAFFLE,
  KA_FAIR_RAFFLE_LIST,
  SET_USER_RAFFLE_TICKET,
  KA_FAIR_RAFFLE_LIST_CLOSED,
  GET_SLIDER_PROMO,
  SET_PRODUCT_RAFFLE_COUNT,
  KA_PREVIEW_RAFFLE,
  GET_COLLECTION_KICKFAIR,
  GET_COLLECTION_STEAL_DEAL,
  GET_COLLECTION_STEAL_DEAL_LIST,
  GET_COLLECTION_SPECIAL_DEALS_GOLD,
  GET_COLLECTION_SPECIAL_DEALS_CAPSULE,
  GET_IMAGE_BANNER_SPECIAL_DEALS_GOLD,
  GET_IMAGE_BANNER_SPECIAL_DEALS_CAPSULE,
  GET_LOCAL_BRANDS_PRODUCT,
  GET_IMAGE_BANNER_LOCAL_BRANDS,
  GET_LOCAL_BRANDS_BRANDS,
  SCROLL_TO_SECTION,
  GET_KICKFAIR_SETTING,
  GET_IMAGE_BANNER_MERCHANDISE,
  GET_MERCHANDISE_PRODUCT,
  KA_POST_RAFFLE_ENTRY,
  GET_COLLECTION_LOCAL_BRANDS,
  GET_COLLECTION_EXCLUSIVE_LAUNCH,
  GET_COLLECTION_EXCLUSIVE_LAUNCH_LIST,
  GET_COLLECTION_SURPRISE_DROP,
  GET_COLLECTION_SURPRISE_DROP_LIST,
  GET_POPULAR_BRANDS,
  GET_COLLECTION_SNEAKERS_NOVEMBAZAR,
  GET_COLLECTION_STREETWEAR_NOVEMBAZAR,
  GET_COLLECTION_LUXURY_NOVEMBAZAR,
  GET_COLLECTION_LIFESTYLE_NOVEMBAZAR,
  GET_RAFFLE_BANNER,
  SET_PRODUCT_RAFFLE_ENTRY,
  GET_COLLECTION_FLASH_SALE
};
